import { Injectable } from '@angular/core';
import { Api } from '../api';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ILogin } from './interfaces/login.interface';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends Api {

  private accessToken: string;
  private permissions: string[];
  private readonly cookieTokenName = 'sss-token';
  private readonly cookiePermissionName = 'sss-permissions';

  public unauthorized$ = new Subject();

  constructor(
    http: HttpClient,
    private cookieService: CookieService,
  ) {
    super(http, undefined, 'auth');
    this.restore();
  }

  private restore(): void {
    this.accessToken = this.cookieService.get(this.cookieTokenName);
    const permissions = this.cookieService.get(this.cookiePermissionName);
    if (permissions) {
      this.permissions = JSON.parse(permissions);
    }
  }

  login(username: string, password: string): Observable<any> {
    return this.post({ username, password }, '/login')
      .pipe(tap((res: ILogin) => {
        const accessToken = res.access_token;
        if (!accessToken || accessToken.length === 0) {
          throw new Error('Response token is invalid');
        }
        this.accessToken = accessToken;
        this.permissions = res.permissions;
        this.cookieService.set(this.cookieTokenName, accessToken, 3600, '/');
        this.cookieService.set(this.cookiePermissionName, JSON.stringify(res.permissions), 3600, '/');
      }));
  }

  getToken(): string {
    return this.accessToken;
  }

  getPermissions(): string[] {
    return this.permissions;
  }

  hasPermission(guard: string): boolean {
    return this.permissions.includes(guard);
  }

  logout(): void {
    this.accessToken = undefined;
    this.cookieService.delete(this.cookieTokenName);
    this.cookieService.delete(this.cookiePermissionName);
  }
}
